/**
 * ScamBlocker AI — App Layout
 * Sidebar + Topbar + Content area
 */

import { Outlet } from 'react-router';
import { useUIStore } from '@/shared/stores/uiStore';
import styles from './AppLayout.module.css';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export function AppLayout() {
  const sidebarCollapsed = useUIStore((s) => s.sidebarCollapsed);

  return (
    <div className={styles.layout}>
      <a href="#main-content" className="skip-link">
        Ana içeriğe geç
      </a>
      <Sidebar />
      <div className={`${styles.main} ${sidebarCollapsed ? styles.collapsed : ''}`}>
        <Topbar />
        <main id="main-content" className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
